import Tag from './Tag';

export default Tag;
export { Tag };
export type { TagProps } from './interface';
